import Component from 'react-pure-render/component';
import Panel from 'portaltransparencia-common/components/Panel.react';
import { Col, Row } from 'react-bootstrap';
import Input from 'portaltransparencia-common/components/EloInput.react';
import FilterButtons from '../components/FilterButtons.react';
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Map, fromJS } from 'immutable';
import {
  onChange,
  resetCrud
} from 'portaltransparencia-common/crud/Actions.js';
import { addFilterUrl } from 'portaltransparencia-common/libs/AddFilter';
import { findRepassesRecebidos, findRepassesEnviados } from './Actions.js';

const CRUD_KEY = 'filtroRepasses';

const MESES = fromJS([
  { value: '01', nome: 'Janeiro' },
  { value: '02', nome: 'Fevereiro' },
  { value: '03', nome: 'Março' },
  { value: '04', nome: 'Abril' },
  { value: '05', nome: 'Maio' },
  { value: '06', nome: 'Junho' },
  { value: '07', nome: 'Julho' },
  { value: '08', nome: 'Agosto' },
  { value: '09', nome: 'Setembro' },
  { value: '10', nome: 'Outubro' },
  { value: '11', nome: 'Novembro' },
  { value: '12', nome: 'Dezembro' }
]);

export class RepassesRecebidosFiltro extends Component {
  static propTypes = {
    filtros: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    resetCrud: PropTypes.func.isRequired,
    findRepassesRecebidos: PropTypes.func.isRequired,
    findRepassesEnviados: PropTypes.func.isRequired,
    titulo: PropTypes.string.isRequired
  };

  onChangeFiltro = event => {
    this.props.onChange(CRUD_KEY, event);
  };

  montaFilter = () => {
    const { filtros } = this.props;
    let filter = '';

    const orgao = filtros.get('orgao');
    if (orgao && orgao.trim()) {
      filter = addFilterUrl(
        filter,
        `orgao=${encodeURIComponent(orgao.trim())}`
      );
    }

    const mesInicial = filtros.get('mesInicial', '01');
    if (mesInicial) {
      filter = addFilterUrl(filter, `mesInicial=${mesInicial}`);
    }

    const mesFinal = filtros.get('mesFinal', '12');
    if (mesFinal) {
      filter = addFilterUrl(filter, `mesFinal=${mesFinal}`);
    }

    return filter;
  };

  onConsultaRepasses = event => {
    event && event.preventDefault();
    const queryFilter = this.montaFilter();

    if (this.props.tipoRepasse === 'receita') {
      this.props.findRepassesRecebidos(queryFilter);
    } else {
      this.props.findRepassesEnviados(queryFilter);
    }

    this.refs.panelFiltro && this.refs.panelFiltro.collapse();
  };

  onResetFiltro = () => {
    this.props.resetCrud(CRUD_KEY);
    const filtroPadrao = 'mesInicial=01&mesFinal=12';

    if (this.props.tipoRepasse === 'receita') {
      this.props.findRepassesRecebidos(filtroPadrao);
    } else {
      this.props.findRepassesEnviados(filtroPadrao);
    }
  };

  renderMeses = mes => (
    <option key={mes.get('value')} value={mes.get('value')}>
      {mes.get('nome')}
    </option>
  );

  render() {
    const { filtros, titulo } = this.props;

    return (
      <Panel title={titulo} isForm mobileClose ref="panelFiltro">
        <form>
          <Row>
            <Col xs={12} sm={6} md={6}>
              <Input
                id="orgao"
                name="orgao"
                ref="orgao"
                placeholder="Órgão"
                label="Órgão"
                type="text"
                onChange={this.onChangeFiltro}
                value={filtros.get('orgao')}
              />
            </Col>
            <Col xs={6} sm={3} md={3}>
              <Input
                id="mesInicial"
                name="mesInicial"
                ref="mesInicial"
                label="Mês Inicial"
                type="select"
                value={filtros.get('mesInicial', '01')}
                onChange={this.onChangeFiltro}
              >
                {MESES.map(this.renderMeses)}
              </Input>
            </Col>
            <Col xs={6} sm={3} md={3}>
              <Input
                id="mesFinal"
                name="mesFinal"
                ref="mesFinal"
                label="Mês Final"
                type="select"
                value={filtros.get('mesFinal', '12')}
                onChange={this.onChangeFiltro}
              >
                {MESES.map(this.renderMeses)}
              </Input>
            </Col>
          </Row>
          <FilterButtons
            idBtnPesquisa="btnFiltrar"
            idBtnReset="btnResetFiltrar"
            onConsulta={this.onConsultaRepasses}
            onReset={this.onResetFiltro}
          />
        </form>
      </Panel>
    );
  }
}

function mapStateToProps(state) {
  return {
    filtros: state.crud.getIn([CRUD_KEY, 'currentRecord'], Map({}))
  };
}

export default connect(
  mapStateToProps,
  { onChange, resetCrud, findRepassesRecebidos, findRepassesEnviados },
  null,
  {
    forwardRef: true
  }
)(RepassesRecebidosFiltro);
